// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '4ae59578-f6d9-4393-8cda-3c1c1c4d8c00',
      type: 'Container',
      name: 'wrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '16c1d1fc-20b7-4af2-8159-279c890f4497',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Blue_Header',
      parent: '4ae59578-f6d9-4393-8cda-3c1c1c4d8c00'
    },
    {
      id: 'd580cbcb-6368-4b4c-811d-6c67c1456e81',
      type: 'Sprite',
      name: 'boosterIconShadow',
      className: '',
      x: -132,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.38,
        y: 0.38
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 1016762,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Move_Booster_Shadow',
      parent: '4ae59578-f6d9-4393-8cda-3c1c1c4d8c00',
      stateByName: {
        'hammer-booster': {
          texture: 'Hammer_Booster_Shadow',
          scale: {
            x: 0.38,
            y: 0.38
          },
          tint: '0xf83ba'
        },
        'move-booster': {
          texture: 'Move_Booster_Shadow',
          scale: {
            x: 0.38,
            y: 0.38
          }
        }
      }
    },
    {
      id: '658172d1-b976-4289-804f-e9636c52f2dd',
      type: 'Sprite',
      name: 'boosterIcon',
      className: '',
      x: -135,
      y: -7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.38,
        y: 0.38
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Move_Booster',
      parent: '4ae59578-f6d9-4393-8cda-3c1c1c4d8c00',
      stateByName: {
        'hammer-booster': {
          texture: 'Hammer_Booster',
          scale: {
            x: 0.38,
            y: 0.38
          }
        },
        'move-booster': {
          texture: 'Move_Booster',
          scale: {
            x: 0.38,
            y: 0.38
          }
        }
      }
    },
    {
      id: '7563d4c3-de69-4e9c-89d3-e6c85237b4e1',
      type: 'Text',
      name: 'bodyText',
      className: '',
      x: -60,
      y: -37,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Move a stack to any space or swap with another stack',
      localize: true,
      maxWidth: 251,
      maxHeight: 94,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#1a38a9',
        strokeThickness: 5,
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 240,
        breakWords: false,
        lineHeight: 26,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '4ae59578-f6d9-4393-8cda-3c1c1c4d8c00',
      stateByName: {
        'hammer-booster': {
          text: 'Clears an object on the board',
          localize: true
        }
      }
    },
    {
      id: '1cd07346-ba92-4659-8782-cc1ca62b4666',
      type: 'Sprite',
      name: 'textBubble',
      className: '',
      x: 14,
      y: -85,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Name_Text_Background',
      parent: '4ae59578-f6d9-4393-8cda-3c1c1c4d8c00'
    },
    {
      id: 'cda019b2-b2d6-40f6-b2aa-3b3c6b7f3c55',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 192,
      y: -76,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -79,
        y: -61,
        width: 144,
        height: 136
      },
      texture: 'Close_Button',
      parent: '4ae59578-f6d9-4393-8cda-3c1c1c4d8c00'
    },
    {
      id: 'e9ade65d-e8f9-4efc-b0ee-e00897a524a2',
      type: 'Text',
      name: 'textBubbleText',
      className: '',
      x: 3,
      y: -10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Move',
      localize: true,
      maxWidth: 150,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 200,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '1cd07346-ba92-4659-8782-cc1ca62b4666',
      stateByName: {
        'hammer-booster': {
          localize: true,
          text: 'Hammer'
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'move-booster',
    'hammer-booster'
  ],
  handleResize: false
} as const;

export class BoosterTutorialLayout {
  static raw = raw;
  root!: Container;
  wrapper!: Container;
  boosterIconShadow!: Sprite;
  boosterIcon!: Sprite;
  bodyText!: Text;
  textBubble!: Sprite;
  closeButton!: Sprite;
  textBubbleText!: Text;
  StateName!: 'move-booster' | 'hammer-booster';

  constructor() {
    populate(this, raw);
  }
}
